import React, { useState } from 'react';
import pt from 'prop-types';
import Image, { imageProptypes } from '../../ui/image';
import Dropdown from '../../ui/dropdown';
import { getLanguageName } from '../../../helpers/getLanguageName';
import PdfDownload from './components/pdfDownload';
import Container from '../../../modules/container';
import * as styles from './styles.module.scss';
import Headline, { headlinePropTypes } from '../../ui/headline';

const CMSDownload = ({ headline, image, documents, redesign }) => {
  const langList = [...new Set(documents?.map((item) => item.language))].map(
    (item) => ({ value: item, label: getLanguageName(item) })
  );

  if (!langList.length) {
    return null;
  }

  const [language, setLanguage] = useState(langList[0].value);
  const selectedLang = (e) => {
    setLanguage(e.target.value);
  };

  return redesign ? (
    <Container className={styles.downloadRedesign}>
      {image && <Image {...image} className={styles.imageWrapper} />}
      {headline && (
        <Headline
          text={headline}
          level="h5"
          type="p2"
          variant="semibold"
          className={styles.hl}
        />
      )}
      <div className={styles.downloadWrapper}>
        <Dropdown
          name="language"
          defaultValue={langList[0].value}
          options={langList}
          onSelect={selectedLang}
          withoutLabel
        />
        <div className={styles.resultsWrapper}>
          {documents
            .filter((item) => item.language === language)
            .map((item, index) => (
              <PdfDownload
                {...item.document}
                key={index}
                language={
                  langList.find((lang) => lang.value === language)?.label
                }
                redesign
              />
            ))}
        </div>
      </div>
    </Container>
  ) : (
    <Container className={styles.download}>
      <Container noGap small innerClass={styles.innerContainer}>
        {headline && (
          <Headline
            text={headline}
            level="h3"
            type="h3"
            className={styles.hl}
          />
        )}
        <div className={styles.contentWrapper}>
          {image && <Image {...image} className={styles.imageWrapper} />}
          <div className={styles.downloadWrapper}>
            <Dropdown
              name="language"
              defaultValue={langList[0].value}
              options={langList}
              onSelect={selectedLang}
            />
            <div className={styles.resultsWrapper}>
              {documents
                .filter((item) => item.language === language)
                .map((item, index) => (
                  <PdfDownload {...item.document} key={index} />
                ))}
            </div>
          </div>
        </div>
      </Container>
    </Container>
  );
};

CMSDownload.propTypes = {
  headline: pt.shape(headlinePropTypes),
  image: pt.shape(imageProptypes),
  documents: pt.array.isRequired,
  headlineAsH1: pt.bool,
  redesign: pt.bool, // Added for softlaunch redesign
};

export default CMSDownload;
